import styled from 'styled-components';

const InnerSection = styled.div`
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
`;

const InnerGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  width: 100%;
  flex: 0.4;
  border-bottom: 1px solid #c6c6c6;
  padding-bottom: 50px;
  > div:first-child {
    flex: 0.4;
  }
  > div:last-child {
    flex: 0.6;
  }
`;

export { InnerSection, InnerGroup };
